import {EntityService} from '../../../service/EntityService';

export class IntegrationDevice extends EntityService {

  static entity = 'app/integration-device';
}
